import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	AddBannerContainer,
	AddItemsContainer,
} from "./style";
import { BannerItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useBannerContext } from "../../context/BannerContext/BannerContext";

const AddBanner = () => {
	const { addBanner, operationStatus } = useBannerContext();
	return (
		<AddBannerContainer>
			<AddItemsContainer>
				<h3>Yeni Banner Ekleme</h3>
				<Divider />
				<Collapse
					items={BannerItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2", "3"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={addBanner} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Banner Ekle
					</MainButtonComponent>
				</ActionButtonComponent>
			</AddItemsContainer>
		</AddBannerContainer>
	);
};

export default AddBanner;
